<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aqbgon/tc-custom/9781398478206.jpg?1705766048158" alt="This image is the cover for the book Ten Stages of Darkness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ten Stages of Darkness
      </h1>
      <p class="bookDescription body article font2">
        <p>In a world plagued by loss and filled with everything she despises, Dawn embarks on a desperate quest for a better life. Miraculously, she is granted a perfect existence surrounded by the love of those she holds dear, including those she has lost. Yet, amidst the sunlit wonders of this new reality, a shadow lingers—the malevolent presence of Htaed, a relentless monster who stalks Dawn relentlessly, even infiltrating her room and haunting her every waking moment. One fateful night, Htaed seizes Dawn, spiriting her away to the depths of their dark dominion. Here, humans are cruelly used as slaves, their life force drained until they become wandering souls, eternally trapped within the foreboding castles and grounds of Hell. To escape this harrowing realm, Dawn must endure a treacherous journey through ten stages, each one representing her deepest fears and those of her fellow captives. Only by conquering these stages can she hope to return home to the real world. Yet, failure carries a grim consequence: should Dawn falter, she will be condemned to serve Htaed and the other merciless rulers of this lower kingdom until her spirit withers away, becoming just another lost soul in the vast abyss of torment.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amiere C. Alexander
      </h2>
      
      <p class="authorDescription body article">Amiere C. Alexander wrote this book as a 12-year-old and now shares this book years later. This book was originally inspired by a dream at eight years old which eventually made its way into many aspects and sections of this book. She hopes to continue writing in the future and inspire others to do the same.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58be0626